export default "__VITE_ASSET__CZg3NhY9__"